import { TxpOptionState } from '../store/schema/TxpOptionState';
import getStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull } from 'owa-options-core';
import { saveCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

export interface SaveTxpOptionState {
    optionState: TxpOptionState;
    calendarConfiguration: MailboxCalendarConfiguration;
}

/**
 * Action called when we save the txp options
 */
export default select<SaveTxpOptionState>({
    optionState: () => getStore(),
    calendarConfiguration: () => getCalendarConfiguration(),
})(
    action('saveTxpOption')(async function saveTxpOption(state?: SaveTxpOptionState) {
        let { optionState, calendarConfiguration } = state;

        let CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(
            optionState.CreateEventsFromEmailAsPrivate,
            calendarConfiguration.CreateEventsFromEmailAsPrivate
        );

        let EventsFromEmailEnabled = getFallbackValueIfNull(
            optionState.EventsFromEmailEnabled,
            calendarConfiguration.EventsFromEmailEnabled
        );

        let partialCalendarMailboxConfiguration: MailboxCalendarConfiguration = {
            CreateEventsFromEmailAsPrivate,
            EventsFromEmailEnabled,
        };

        // Push the rest of the events to the mailboxConfiguration
        Object.keys(optionState.Events).map(eventType => {
            let val = getFallbackValueIfNull(
                optionState.Events[eventType],
                calendarConfiguration[eventType]
            );
            partialCalendarMailboxConfiguration[eventType] = val;
        });

        await saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);
    })
);
